<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-row class="mx-0">
            <h2>{{ $t('global.menu.backoffice.voucher') }}</h2>
        </v-row>
        <v-row class="mb-3">
            <v-data-table-server v-model:items-per-page="itemsPerPage" :items-per-page-options="pageOptions"
                density="compact" :headers="headers" :items="serverItems" :items-length="totalItems" :loading="loading"
                :search="search" item-value="name" @update:options="loadItems" height="60vh" :update:sortBy="updateSortBy"
                :mobile="['xs', 'sm', 'md'].includes($globalState.screenWidth)" class="shop-list-table" fixed-header>
                <template v-slot:top>
                    <v-row>
                        <v-col>
                            <!-- TODO BACKEND SEARCH FUNCTION PAGINATION -->
                            <v-text-field v-model="search" :disabled="false" :placeholder="$t('main.search.placeholder')"
                                variant="outlined" hide-details="true" density="compact" class="pb-2 py-0 bg-white"
                                height="32px">
                                <template v-slot:append-inner>
                                    <v-icon icon="mdi-magnify"></v-icon>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="4" class="text-right">
                            <v-btn color="primary" variant="flat" class="mr-1" rounded="xl" size="large" @click="isCountryDialogOpen = true">
                                {{ $t('global.menu.backoffice.createVoucher') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:[`item.active`]="{value}">
                    <v-switch :value="value" density="compact" hide-details="true"></v-switch >
                </template>
                <template v-slot:[`item.shop`]="{value}">
                    {{ value ? value.name : '' }}
                </template>
                <template v-slot:[`item.shop.city`]="{value}">
                    {{ value}}
                </template>
                <template v-slot:[`item.amount`]="{value}">
                    {{ $convertCentsToEuros(value)}}
                </template>
                <template v-slot:[`item.created`]="{value}">
                    {{ $formatDate(value)}}
                </template>

                <template v-slot:[`item.controls`]>
                    <v-btn color="primary" variant="flat" size="32" class="mr-1">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn color="primary" variant="flat" size="32" class="mr-1">
                        <v-icon>mdi-email</v-icon>
                    </v-btn>
                </template>

            </v-data-table-server>
        </v-row>

    </v-container>
</template>

<script>
import { ref, inject, getCurrentInstance, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

export default {
    components: {

    },
    setup() {

        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const { t, locale } = useI18n();
        const updateSortBy = (newSort) => {
            proxy.sortBy = newSort;
        }

        return {
            selectedLanguage,
            updateSortBy
        };
    },

    watch: {

    },

    data: () => ({
        itemsPerPage: 50,
        sortBy:[],
        pageOptions: [
            { value: 50, title: '50' },
            { value: 100, title: '100' },
            { value: -1, title: '$vuetify.dataFooter.itemsPerPageAll' }
        ],
        headers: [
            { title: 'Code', key: 'code', align: 'start', maxWidth: "150px" },
            { title: 'email', key: 'email', align: 'start', maxWidth: "200px" },
            { title: 'value', key: 'amount', align: 'start',maxWidth: '70px' },
            { title: 'created', key: 'created', align: 'start', maxWidth: "150px" },
            { title: 'expires', key: 'expires', align: 'start' },
            { title: 'redeemed', value: "redeemed", align: 'start',maxWidth: '70px'  },
            { title: 'redeemer', value: "shop", align: 'start',  maxWidth: "200px"},
            { title: 'redeemer-city', value: "shop.city", align: 'start',maxWidth: '100px'  },
            { title: 'Actions', value: "controls", align: 'end', sortable: false },
        ],
        search: '',
        serverItems: [],
        loading: true,
        totalItems: 0,
    }),

    computed: {
    },

    mounted() {
    },

    methods: {
        loadItems({ page, itemsPerPage, sortBy }) {
            this.loading = true
            console.log(this.search)
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            this.$axios.get(this.search.length >= 1 ? "/backoffice/voucher/query" : "/backoffice/v2/voucher", {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-USER': username
                },
                params: {
                    sortColumn: sortBy[0]?.key,
                    sortDirection: sortBy[0]?.order.toUpperCase(),
                    activeOnly: false,
                    ...(this.search.length >= 1 ? { search: this.search, resultsPerPage: itemsPerPage, page: page - 1 } : { page: page - 1, resultsPerPage: itemsPerPage })
                }
            })
                .then(this.itemsFetched)
                .catch(error => {
                    console.error("Error fetching user data:", error);
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if (error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        // Optionally log the user out or redirect to login page
                    }
                });
        },
        itemsFetched(response) {
            console.log(response)
            this.serverItems = response.data.data;
            this.totalItems = response.data.totalElements
            this.loading = false
        }
    },
}
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 1170px;
    margin-top: 40px;
}
</style>

<style></style>

<style></style>